import $ from 'jquery';
import { preloadSlidesNext, preloadSlidesPrev } from './ajax';

import { getScrollVars, scrollAnimate, scrollSet } from './scroll';
import state from './state';
import {
	getControlEls,
	getFirstSlide,
	getLastSlide,
	getSlidesContainer,
	getSlidesRecipient,
	setSlidesWidthAndHeight,
	shouldRepeat,
	shouldWait
} from './utils';

export function onResize( slider ) {
	const { controlsWidth } = getScrollVars( slider );
	const sliderId = $( slider ).attr( 'id' );
	setSlidesWidthAndHeight( sliderId );

	const { controlLeft, controlRight } = getControlEls( slider );

	controlLeft.width( controlsWidth );
	controlRight.width( controlsWidth );

	const sliderContainer = getSlidesContainer( slider );

	scrollSet( sliderContainer, 0 );
	scrollAnimate( 'set', sliderContainer, getScrollVars( slider ).initialScroll );
}

export function onClickPrev( ctrlPrev ) {
	const slider = ctrlPrev.currentTarget.parentNode;

	console.log( 'shouldWait', slider, shouldWait( slider ) );
	if ( shouldWait( slider ) ) {
		return;
	}

	if ( shouldRepeat( slider ) ) {
		prependLastSlide( slider );
	}

	const slidesContainer = getSlidesContainer( slider );

	const scrollQuantity = getScrollVars( slider ).scrollSize;

	$( slider ).addClass( 'moving' );
	scrollAnimate( 'left', slidesContainer, scrollQuantity, () =>
		onScrollFinishPrev( slider )
	);
}

export function prependLastSlide( slider ) {
	const slidesRecipient = getSlidesRecipient( slider );
	const lastSlide = getLastSlide( slider );
	const clone = lastSlide.clone( true );
	slidesRecipient.prepend( clone );
	const currentScroll = getSlidesContainer( slider ).scrollLeft();

	const reScroll = currentScroll + 1 * getScrollVars( slider ).scrollSize;

	const slidesContainer = getSlidesContainer( slider );
	scrollSet( slidesContainer, reScroll );
}

export function onScrollFinishPrev( slider ) {
	$( slider ).removeClass( 'moving' );

	const repeatMode = shouldRepeat( slider );
	if ( repeatMode ) {
		const lastSlide = getLastSlide( slider );
		lastSlide.remove();

		return;
	}

	preloadSlidesPrev( slider, ( res ) => onLoadSuccessPrev( res, slider ) );
}

export function onLoadSuccessPrev( res, slider ) {
	console.log( 'onLoadSuccessPrev', res );

	const { template, error } = res.data;
	if ( ! res.success && 'no-posts' === error ) {
		$( slider ).removeClass( 'prev-loading' );
		shouldRepeat( slider, true );

		return;
	}

	const sliderId = $( slider ).attr( 'id' );
	state.update(
		sliderId,
		'queriedPrev',
		( queriedPrev ) => queriedPrev + res.data.numEls
	);

	const newSlides = $.parseHTML( template );
	const slidesRecipient = getSlidesRecipient( slider );
	for ( const slide of newSlides ) {
		if ( ! $( slidesRecipient ).find( `#${slide.id}` ).length ) {
			$( slide ).prependTo( slidesRecipient );
		}
	}
	setSlidesWidthAndHeight( sliderId );

	const currentScroll = getSlidesContainer( slider ).scrollLeft();

	const reScroll =
		currentScroll + res.data.numEls * getScrollVars( slider ).scrollSize;

	const slidesContainer = getSlidesContainer( slider );
	scrollSet( slidesContainer, reScroll );

	$( slider ).removeClass( 'prev-loading' );

	shouldRepeat( slider );
}

export function onClickNext( ctrlNext ) {
	const slider = ctrlNext.currentTarget.parentNode;

	if ( shouldWait( slider ) ) {
		return;
	}

	const repeatMode = shouldRepeat( slider );

	if ( repeatMode ) {
		const slidesRecipient = getSlidesRecipient( slider );
		const firstChild = getFirstSlide( slider );
		const clone = firstChild.clone( true );
		$( slidesRecipient ).append( clone );
	}

	const slidesContainer = getSlidesContainer( slider );
	const scrollQuantity = getScrollVars( slider ).scrollSize;

	$( slider ).addClass( 'moving' );
	scrollAnimate( 'right', slidesContainer, scrollQuantity, () =>
		onScrollFinishNext( slider )
	);

	if ( repeatMode ) {
		return;
	}

	preloadSlidesNext( slider, onLoadSuccessNext );
}

export function onLoadSuccessNext( res, slider ) {
	$( slider ).removeClass( 'next-loading' );

	const { template, error, numEls } = res.data;
	if ( ! res.success && 'no-posts' === error ) {
		shouldRepeat( slider, true );
		return;
	}

	if ( ! template ) {
		return;
	}

	const newSlides = $.parseHTML( template );
	const slidesRecipient = getSlidesRecipient( slider );
	for ( const slide of newSlides ) {
		if ( ! $( slidesRecipient ).find( `#${slide.id}` ).length ) {
			slidesRecipient.append( slide );
		}
	}
	const sliderId = $( slider ).attr( 'id' );
	setSlidesWidthAndHeight( sliderId );

	state.update( sliderId, 'queriedNext', ( queriedNext ) => queriedNext + numEls );

	shouldRepeat( slider );
}

export function onScrollFinishNext( slider ) {
	const repeatMode = shouldRepeat( slider );
	const slidesContainer = getSlidesContainer( slider );
	const slidesRecipient = getSlidesRecipient( slider );
	if ( repeatMode ) {
		const currentScroll = $( slidesContainer ).scrollLeft();

		const firstChild = slidesRecipient.find( '.dynamic-slide:first-child' );
		firstChild.hide();

		const scrollSize = getScrollVars( slider ).scrollSize;
		scrollSet( slidesContainer, currentScroll - scrollSize );
		firstChild.remove();
	}
	$( slider ).removeClass( 'moving' );
}
